/**
 * @generated SignedSource<<a5eb3de82a6c557ea83f77313ece9b55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postPreviewFragment$data = {
  readonly scheduledPublishDate: any | null | undefined;
  readonly slug: string;
  readonly space: {
    readonly slug: string;
  } | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"postAttachmentsPreview_post" | "postBottomActionsFragment" | "postContentPreviewFragment" | "postCoverFragment" | "postHeaderFragment">;
  readonly " $fragmentType": "postPreviewFragment";
};
export type postPreviewFragment$key = {
  readonly " $data"?: postPreviewFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"postPreviewFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "club"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "postPreviewFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduledPublishDate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postBottomActionsFragment"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "club",
          "variableName": "club"
        }
      ],
      "kind": "FragmentSpread",
      "name": "postHeaderFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postContentPreviewFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postCoverFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postAttachmentsPreview_post"
    }
  ],
  "type": "Post",
  "abstractKey": null
};
})();

(node as any).hash = "242011f31ad9c850ba02b9f319f3d06f";

export default node;
